import {Link} from "react-router-dom";
import {useContext} from "react";
import AppContext from "../../../context";

const Footer = () => {
    const context = useContext(AppContext);

    return <div className={"border-t border-borderGrey p-4 flex flex-wrap justify-between flex-row gap-1 sm:gap-0"}>
        <p className={"text-sm text-textGrey"}>&copy; {new Date().getFullYear()} {context.domain.name}</p>
        <p className={"text-sm text-textGrey"}>Powered by <a href={"https://surecodesoftware.com/"} rel="noopener noreferrer" target={
            "_blank"
        } className={"text-sm text-textGrey underline"}>Surecode</a></p>
    </div>
}

export default Footer